export default __webpack_public_path__ + "static/media/EnergySaving.26b01cfa.svg";